import axios from "axios";
import { Dispatch, SetStateAction } from "react";
import { AnyIfEmpty } from "react-redux";
import { GET_VENDORS_BY_LOCATION_FAILURE, GET_VENDORS_BY_LOCATION_REQUEST, GET_VENDORS_BY_LOCATION_SUCCESS, RESET_VENDORS_BY_LOCATION_STATE } from "../constants/vendorsByLocation.constants";

const getVendorsByLocationRequest = () => {
    return {
        type: GET_VENDORS_BY_LOCATION_REQUEST,
    };
};

const getVendorsByLocationSuccess = (vendorsData: AnyIfEmpty<object>) => {
    return {
        type: GET_VENDORS_BY_LOCATION_SUCCESS,
        payload: vendorsData,
    };
};

const getVendorsByLocationFailure = (error: string) => {
    return {
        type: GET_VENDORS_BY_LOCATION_FAILURE,
        payload: error,
    };
};

export const getVendorsByLocation = ({
    locationId,
    setTotalCount
}: {
    locationId: string;
    setTotalCount?: Dispatch<SetStateAction<number>>
}) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getVendorsByLocationRequest());
        return axios
            .get(`/admin/vendor/vendorsByLocation/${locationId}`)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    setTotalCount?.(response?.data?.count)
                    dispatch(getVendorsByLocationSuccess(response?.data?.data || []))
                } else {
                    setTotalCount?.(0)
                    dispatch(getVendorsByLocationFailure(response.data.message))
                }
            }).catch((error) => {
                setTotalCount?.(0);
                dispatch(getVendorsByLocationFailure(error?.response?.data?.message || 'Something went wrong'));
            });
    }
}

export const resetVendorsByLocationState = () => {
    return {
        type: RESET_VENDORS_BY_LOCATION_STATE,
    };
}